import '.an{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.hd{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.am{align-items:flex-start;}.ssr-plugin'
import '.do{padding:2rem;}.ssr-plugin'
import '.d7{background:var(--palette-white);}.ssr-plugin'
import '.az{overflow:hidden;}.ssr-plugin'
import '.by{position:absolute;}.ssr-plugin'
import '.ja{top:50%;}.ssr-plugin'
import '.jb{right:1rem;}.ssr-plugin'
import '.jc{transform:translateY(-50%);}.ssr-plugin'
import '.jd{width:120px;}.ssr-plugin'
import '.je{height:120px;}.ssr-plugin'
import '.jf{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ij{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jg{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="an l hd d e ab am do d7 az"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="by ja jb jc jd je jf d r ab"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="an ij d e am s jg"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
